import { Compass } from "lucide-react";
import { ActionButton } from "../components/buttons/ActionButton";
import { EmptyState } from "../components/empty/EmptyState";
import { useI18n } from "../i18n";

export function NotFoundPage() {
  const { t } = useI18n();

  return (
    <section className="page">
      <EmptyState
        icon={Compass}
        title={t("common.notFound")}
        description="Το νέο V2 app shell χειρίζεται όλα τα paths μέσω SPA routing."
      />
      <div className="quick-actions">
        <ActionButton to="/">{t("common.back")}</ActionButton>
      </div>
    </section>
  );
}
